import React, { useState, useRef, useEffect } from 'react';

interface IUserVideoProps {
    stream: any;
}

function PreviewVideo(props: IUserVideoProps) {
    const userVideoRef = useRef<HTMLVideoElement>(null);

    const { stream } = props;

    useEffect(() => {
        userVideoRef.current!.srcObject = stream;
        userVideoRef.current!.volume = 0;
    }, [stream]);

    return <video ref={userVideoRef} autoPlay className="previewVideo" />;
}

export default PreviewVideo;
